import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'ark-lib-multiple-founders-info-modal',
  templateUrl: './multiple-founders-info-modal.component.html',
  styleUrls: ['./multiple-founders-info-modal.component.css'],
})
export class MultipleFoundersInfoModalComponent  implements OnInit {

  constructor(
    private modalCtrl: ModalController,
  ) { }

  ngOnInit() {}

   async close() {
    const top = await this.modalCtrl.getTop();

    if (top) {
      await this.modalCtrl.dismiss();
    } 
  }
}
